// ./SchoolCode/index.js
import React, { Component } from "react";
import Paging from "../../Paging";
import AdmissionApi, { acz } from "../../../Services/AdmissionApi";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";


class SchoolCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selectedText: "",
      page: 1,
      pageSize: 10,
      totalPages: 1,
      isLoading: false,
    };

    this.admissionsService = new AdmissionApi();
    this.admissionsService.setObj({ clientId: acz.clientId, appId: acz.appId });
  }

  componentDidMount() {
    this.getData(1);
  }

  updateState = (response) => {
  
    console.log("GET /v1/school-codes response:", response);

    const d = response && response.data ? response.data : {};
    const embedded = d._embedded || {};
  const list =
  embedded["school-codes"] ||    
  embedded.school_codes ||        
  embedded.schools ||             
  [];



    this.setState({
      items: Array.isArray(list) ? list : [],
      page: typeof d.page === "number" ? d.page : 1,
      totalPages: typeof d.pageCount === "number" ? d.pageCount : 1,
      isLoading: false,
    });
  };

  // ---- list with paging + search
  getData = (page = 1) => {
    const { selectedText, pageSize } = this.state;
  
    this.setState({ isLoading: true });
  
    const q = (selectedText || "").trim();
    const filters = q ? "&search=" + encodeURIComponent(q) : "";
  
    const url =
      "v1/school-codes?page=" +
      page +
      "&pageSize=" +
      pageSize +
      filters;
  
    this.admissionsService.GetStudentsData(this.updateState, url, {
      client_id: acz.clientId,
      app_key: acz.appId,
    });
  };
  

  handleFilterInputChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  filterList = (e) => {
    e.preventDefault();
    this.getData(1);
  };

  clearFilter = () => {
    this.setState({ selectedText: "" }, () => this.getData(1));
  };

  handlePageChange = (page) => this.getData(page);

  deleteItem = (row) => {
    if (!row || !row.id) return;
  
    confirmAlert({
      title: "Confirm ?",
      message: "Are you sure you want to delete this school code?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.admissionsService.deleteStudent(
              (res) => {
                if (res && res.status === 200) {
                  toast.success("School code deleted.");
                  this.getData(this.state.page);
                } else {
                  toast.error("Delete failed.");
                }
              },
              "v1/school-codes",
              row.id
            );
          },
        },
        {
          label: "No",
          onClick: () => {
            console.log("Cancel");
          },
        },
      ],
    });
  };
  

  render() {
    const { items, page, totalPages, selectedText, isLoading } = this.state;
    const { showDetails, updateRoutePage } = this.props;

    return (
      <section className="dash-alerts">
        <form>
          <div className="alert-filter">
            <input
              id="selectedText"
              type="text"
              className="form-control alert-filter__input mr-2"
              placeholder="School name or code"
              value={selectedText}
              onChange={this.handleFilterInputChange}
            />
            <button type="submit" onClick={this.filterList} className="btn btn--primary">
              Submit
            </button>
            <button type="button" onClick={this.clearFilter} className="btn btn--default ml-2">
              Clear
            </button>
            <button
              type="button"
              onClick={() => showDetails("school-code-form", {})}
              className="btn btn--new ml-2"
              title="Add"
            >
              <i className="icon-plus" />
            </button>
          </div>
        </form>

        <table className="table table-responsive alert-table">
          <thead>
            <tr>
              <th scope="col">School Name</th>
              <th scope="col">School Code</th>
              <th scope="col" style={{ width: 120 }}>Actions</th>
            </tr>
          </thead>
        <tbody>
          {isLoading && (
            <tr>
              <td colSpan={3} className="text-center text-muted">
                Loading…
              </td>
            </tr>
          )}

          {!isLoading &&
            items.map((row) => (
              <tr key={row.id}>
                <td>{row.school_name}</td>
                <td>{row.school_code}</td>
                <td className="d-flex">
                  <button
                    className="btn btn-link alert-table__link"
                    onClick={() => showDetails("school-code-form", row)}
                    title="Edit"
                  >
                    <i className="icon-pencil" />
                  </button>
                  <button
                    className="btn btn-link alert-table__link"
                    onClick={() => this.deleteItem(row)}
                    title="Delete"
                  >
                    <i className="icon-trash" />
                  </button>
                </td>
              </tr>
            ))}

          {!isLoading && items.length === 0 && (
            <tr>
              <td colSpan={3} className="text-center text-muted">
                No records found
              </td>
            </tr>
          )}
        </tbody>
        </table>

        <Paging page={page} totalPages={totalPages} onChange={this.handlePageChange} />
      </section>
    );
  }
}

export default SchoolCode;



/** WEBPACK FOOTER **
 ** ./src/components/Admin/SchoolCode/index.js
 **/